<script setup>
import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import { ref, computed, onMounted } from 'vue';
import PrimeFormModal from './PrimeFormModal.vue';
import formatNumber from '../../utils/format-number';
import { PrimeFeatures } from '../../constants/prime/features';
import ChannelsModal from "./ChannelsModal.vue";
import TvPlusMobileModal from "./TvPlusMobileModal.vue";
import StreamsModal from "./StreamsModal.vue";

const showFormModal = ref(false);
const showChannelsModal = ref(false);
const showTvPlusMobileModal = ref(false);
const showStreamsModal = ref(false);

const FLOORS_MIN = 1;
const FLOORS_MAX = 5;

const square = ref(0);
const floors = ref(FLOORS_MIN);

const pricesBySquare = {
    100: 35999,
    200: 37999,
    300: 39999,
    400: 41999,
    500: 43999,
    600: 45999,
    700: 47999,
    800: 49999,
    900: 51999,
    1000: 53999,
};

const modulesBySquare = {
    100: 1,
    200: 2,
    300: 3,
    400: 4,
    500: 5,
    600: 6,
    700: 7,
    800: 8,
    900: 9,
    1000: 10,
};

const price = computed(() => {
    const key = Object.keys(pricesBySquare).find((key) => square.value <= key);

    return pricesBySquare[key];
});

const modulesCount = computed(() => {
    const key = Object.keys(modulesBySquare).find((key) => square.value <= key);

    return modulesBySquare[key];
});

onMounted(() => {
    const slider = document.getElementById('slider');

    noUiSlider.create(slider, {
        start: [200],
        step: 10,
        connect: 'lower',
        range: {
            'min': 100,
            'max': 1000
        },
        format: {
            to: function (value) {
                return Math.round(value);
            },
            from: function (value) {
                return value;
            },
        },
    });

    slider.noUiSlider.on('update', function (values, handle) {
        square.value = values[0];
    });
});

const featuresWithLinks = ['tvPlus', 'tvPlusMobile', 'tvStreams'];

const onFeatureClick = (feat) => {
    if (feat === 'tvPlus') {
        showChannelsModal.value = true;
    }

    if (feat === 'tvPlusMobile') {
        showTvPlusMobileModal.value = true;
    }

    if (feat === 'tvStreams') {
        showStreamsModal.value = true;
    }
};
</script>

<template>
    <div class="tariff-constructor">
        <div class="tariff-constructor__inner">
            <img class="tariff-constructor__bg" src="/img/landings/prime/tariff-header.png" alt="tariff-header">

            <div class="tariff-constructor-header">
                <p class="tariff-constructor-header__title">Тариф <strong>DIAMOND</strong></p>
                <div class="tariff-constructor-header__div"></div>
            </div>

            <div class="tariff-constructor-params">
                <div class="tariff-constructor-params__inner">
                    <div class="tariff-square-range">
                        <p  class="tariff-square-range__title">Укажите площадь дома <strong>{{ square }} кв.м.</strong></p>

                        <div class="tariff-square-range__wrap">
                            <div id="slider" class="tariff-square-range__inp"></div>
                            <div class="tariff-square-range__handle tariff-square-range__handle--first"></div>
                        </div>
                    </div>

                    <div class="tariff-constructor-modules">
                        • Wi-Fi mesh система
                        <template v-if="modulesCount === 1">из <strong>1 модуля</strong></template>
                        <template v-else>из <strong>{{ modulesCount }} модулей</strong></template>
                    </div>

                    <div class="tariff-constructor__cost">
                        <span class="tariff-constructor__price">{{ formatNumber(price) }}</span> ₸/мес
                    </div>

                    <div class="tariff-constructor__submit">
                        <button type="button" class="tariff-constructor__btn" @click="showFormModal = true">
                            Оформить
                        </button>
                    </div>
                </div>
            </div>

    <!--        <div class="tariff-constructor-params tariff-constructor-floors">-->
    <!--            <p class="tariff-constructor-floors__title">-->
    <!--                Этажность дома или квартиры-->
    <!--            </p>-->

    <!--            <div class="tariff-floors-inp">-->
    <!--                <button-->
    <!--                    type="button"-->
    <!--                    :disabled="floors === FLOORS_MIN"-->
    <!--                    class="tariff-floors-inp__btn"-->
    <!--                    @click="floors -= 1"-->
    <!--                >-->
    <!--                    - -->
    <!--                </button>-->
    <!--                <div class="tariff-floors-inp__val">{{ floors }}</div>-->
    <!--                <button-->
    <!--                    type="button"-->
    <!--                    :disabled="floors === FLOORS_MAX"-->
    <!--                    class="tariff-floors-inp__btn"-->
    <!--                    @click="floors += 1"-->
    <!--                >-->
    <!--                    +-->
    <!--                </button>-->
    <!--            </div>-->
    <!--        </div>-->

            <div class="tariff-constructor-body">
                <p class="tariff-option-title">Вам будут доступны:</p>

                <div class="tariff-constructor-body__options">
                    <ul
                        v-for="features in PrimeFeatures"
                        class="tariff-option-list"
                    >
                        <li
                            v-for="(option, index) in features"
                            :key="index"
                            :class="['tariff-option-list__item', { 'tariff-option-list__item--link': featuresWithLinks.includes(option.name) }]"
                            @click="onFeatureClick(option.name)"
                        >
                            <img class="tariff-option-list__check" src="/img/landings/prime/check.svg" alt="tariff-check">

                            <div>
                                <p class="tariff-option-list__title">{{ option.title }}</p>
                                <p class="tariff-option-list__text">{{ option.text }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <PrimeFormModal v-model="showFormModal" :square="square" :floors="floors" :modules="modulesCount" @close="showFormModal = false" />
    <ChannelsModal v-model="showChannelsModal" @close="showChannelsModal = false" />
    <TvPlusMobileModal v-model="showTvPlusMobileModal" @close="showTvPlusMobileModal = false" />
    <StreamsModal v-model="showStreamsModal" @close="showStreamsModal = false" />
    <notifications classes="v3-notification" />
</template>

<style lang="scss">
@import 'resources/sass/variables';

.prime-modal {
    .vfm__content {
        border-radius: 16px;
        width: 100%;
        border: 1px solid #FEE7A2;

        @media screen and (max-width: $mobile-max-width) {
            border-radius: 16px 16px 0 0;
        }
    }

    &__header {
        top: 0;
        position: sticky;
    }
}

.tariff-constructor {
    position: relative;
    margin: 36px auto;
    width: 100%;
    border-radius: 16px;
    padding: 1px;
    background: linear-gradient(225deg, #FFE3AD 10.21%, rgba(254, 231, 162, 0.12) 33.87%, rgba(251, 230, 164, 0) 48.62%, rgba(248, 229, 165, 0.16) 71.78%, #BF8F3B 100%);
    color: white;

    @media screen and (max-width: $mobile-max-width) {
        max-width: 352px;
    }

    &__inner {
        position: relative;
        background: linear-gradient(223.67deg, #2C2A2A -0.51%, #0F0E0E 74.96%);
        border-radius: inherit;
    }

    &__bg {
        position: absolute;
        display: block;
        width: 100%;
        max-height: 300px;
        object-fit: cover;
        border-radius: inherit;
        mask-image: linear-gradient(to bottom, black 40%, transparent 100%);
        mask-size: 100% 100%;
        mask-repeat: no-repeat;
    }

    &__total {
        margin-top: 20px;
        font-size: 16px;
        color: white;
        opacity: 0.65;
    }

    &__cost {
        margin-top: 24px;
        font-size: 24px;
        color: white;
        font-weight: $font-weight-semibold;
        text-align: center;
    }

    &__price {
        padding: 0 8px;
        font-size: 36px;
    }

    &__submit {
        display: flex;
        justify-content: center;
    }

    &__btn {
        @include reset-button;

        margin: 24px auto 8px;
        min-width: 240px;
        height: 50px;
        padding: 0 16px;
        background: white;
        color: $black-font;
        font-size: 18px;
        border-radius: 25px;

        @media (hover: hover) {
            &:hover {
                color: $blue;
            }
        }
    }
}

.tariff-constructor-header {
    position: relative;
    height: 88px;
    border-radius: 16px 16px 0 0;
    overflow: hidden;

    &__title {
        position: absolute;
        z-index: 1;
        background: linear-gradient(180deg, #040404 0%, rgba(1, 1, 1, 0) 100%);
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        color: white;

        strong {
            margin-left: 8px;
            background: linear-gradient(90deg, #C37C28 0%, #E4A52A 40.91%, #E4D18B 95.79%);
            color: transparent;
            background-clip: text;
        }
    }
}

.tariff-constructor-modules {
    margin-top: 20px;
    color: #DEB157;
    font-size: 15px;

    strong {
        font-weight: $font-weight-bold;
    }
}

.tariff-constructor-params {
    position: relative;
    max-width: 600px;
    margin: 0 auto;
    padding: 1px;
    background: linear-gradient(225deg, #FFE3AD 10.21%, rgba(254, 231, 162, 0.12) 33.87%, rgba(251, 230, 164, 0) 48.62%, rgba(248, 229, 165, 0.16) 71.78%, #BF8F3B 100%);
    border-radius: inherit;

    @media screen and (max-width: $mobile-max-width) {
        border-radius: 0;
    }

    &__inner {
        padding: 24px 140px;
        background: #2C2A2A;
        border-radius: inherit;

        @media screen and (max-width: $mobile-max-width) {
            padding: 24px 16px;
        }
    }
}

.tariff-square-range {
    max-width: 352px;

    &__title {
        display: flex;
        justify-content: space-between;
        font-size: 16px;

        strong {
            font-size: 18px;
            font-weight: $font-weight-bold;
        }
    }

    &__wrap {
        position: relative;
        margin: 10px;
    }

    &__inp {
        height: 6px;
        border-radius: 3px;
        background: rgba(white, 0.6);
        box-shadow: none;
        border: none;
    }

    &__handle, .noUi-handle {
        position: absolute;
        top: -7px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: none;
        box-shadow: none;
        padding: 2px;
        background: linear-gradient(90deg, #C37C28 0%, #E4A52A 40.91%, #E4D18B 95.79%);
        cursor: pointer;

        &::before {
            position: static;
            display: block;
            width: 100%;
            height: 100%;
            background: white;
            border-radius: inherit;
            content: '';
        }

        &::after {
            display: none;
        }
    }

    &__handle--first {
        left: -10px;
        z-index: 1;
        pointer-events: none;
    }

    .noUi-handle {
        right: -10px;
    }

    .noUi-connect {
        background: linear-gradient(90deg, #E4D18B 0%, #DCA13E 40.91%, #BB8D3B 95.79%);
    }
}

.tariff-constructor-floors {
    &__title {
        font-size: 16px;
        color: white;
    }
}

.tariff-floors-inp {
    margin-top: 16px;
    display: inline-flex;
    border-radius: 6px;
    background: linear-gradient(90deg, #C37C28 0%, #E4A52A 40.91%, #E4D18B 95.79%);
    overflow: hidden;
    padding: 1px;

    &__btn {
        @include reset-button;

        width: 36px;
        height: 40px;
        padding: 0 0 2px;
        color: white;
        background: #424242;
        font-size: 24px;

        &:disabled {
            color: rgba(white, 0.4);
        }

        &:first-child {
            border-radius: 6px 0 0 6px;
        }

        &:last-child {
            border-radius: 0 6px 6px 0;
        }
    }

    &__val {
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        width: 40px;
        font-size: 18px;
        background: #2C2A2A;
        font-weight: $font-weight-bold;
    }
}

.tariff-constructor-body {
    padding: 24px;
    border-radius: 0 0 16px 16px;

    @media screen and (max-width: 1000px) {
        padding: 24px 16px;
    }

    &__options {
        display: grid;
        grid-gap: 16px;
        grid-template-columns: repeat(4, 1fr);

        @media screen and (max-width: 1000px) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media screen and (max-width: $mobile-max-width) {
            grid-template-columns: 1fr;
        }
    }
}

.tariff-option-title {
    margin-bottom: 16px;
    background: linear-gradient(90deg, #C37C28 0%, #E4A52A 40.91%, #E4D18B 95.79%);
    color: transparent;
    background-clip: text;
    font-size: 16px;
    font-weight: $font-weight-semibold;
    text-align: center;
}

.tariff-option-list {
    font-size: 16px;
    color: white;

    &__item {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-bottom: 16px;
    }

    &__check {
        margin-right: 16px;
    }

    &__title {
        font-weight: $font-weight-semibold;
    }

    &__text {
        margin-top: 4px;
        opacity: 0.65;

        .tariff-option-list__item--link & {
            color: #DDAA4C;
        }
    }
}
</style>
